import { Undo2 } from 'lucide-react'
import { useState } from 'react'
import { Button } from '@/components/ui/button'
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
} from '@/components/ui/dialog'
import { Textarea } from '@/components/ui/textarea'

interface ReturnEvaluationDialogProps {
  evaluationLabel: string
  isPending: boolean
  /** 成功した場合のみ true を返す */
  onConfirm: (reason: string) => Promise<boolean>
}

export function ReturnEvaluationDialog({
  evaluationLabel,
  isPending,
  onConfirm,
}: ReturnEvaluationDialogProps) {
  const [open, setOpen] = useState(false)
  const [reason, setReason] = useState('')

  const handleConfirm = async () => {
    if (await onConfirm(reason)) {
      setOpen(false)
      setReason('')
    }
  }

  return (
    <Dialog open={open} onOpenChange={setOpen}>
      <DialogTrigger asChild>
        <Button variant="outline" size="sm">
          <Undo2 className="mr-1 h-3.5 w-3.5" />
          {evaluationLabel}を差し戻す
        </Button>
      </DialogTrigger>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>{evaluationLabel}の差し戻し</DialogTitle>
          <DialogDescription>
            差し戻すと評価者が再提出できるようになります。理由は評価者に表示されます。
          </DialogDescription>
        </DialogHeader>
        <Textarea
          placeholder="差し戻し理由"
          value={reason}
          onChange={(e) => setReason(e.target.value)}
          rows={3}
        />
        <DialogFooter>
          <Button variant="ghost" onClick={() => setOpen(false)}>
            キャンセル
          </Button>
          <Button onClick={handleConfirm} disabled={!reason.trim() || isPending}>
            {isPending ? '送信中...' : '差し戻す'}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  )
}
